import { useInView } from 'framer-motion';
import { useRef } from 'react';

interface AnimatedTextProps {
  text: string;
  className?: string;
  delay?: number;
  as?: 'h1' | 'h2' | 'h3' | 'p' | 'span';
  letterByLetter?: boolean;
}

const AnimatedText = ({ 
  text, 
  className = '', 
  delay = 0,
  as: Component = 'span',
  letterByLetter = false
}: AnimatedTextProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  if (letterByLetter) {
    const letters = text.split('');
    
    return (
      <Component ref={ref} className={`overflow-hidden descender-safe ${className}`}>
        {letters.map((letter, index) => (
          <span
            key={index}
            className="descender-safe-inline"
            style={{
              display: 'inline-block',
              opacity: isInView ? 1 : 0,
              transform: isInView ? 'translateY(0)' : 'translateY(100%)',
              transition: `opacity 0.4s ease-out ${delay + index * 0.03}s, transform 0.4s ease-out ${delay + index * 0.03}s`,
              willChange: 'opacity, transform',
            }}
          >
            {letter === ' ' ? '\u00A0' : letter}
          </span>
        ))}
      </Component>
    );
  }

  const words = text.split(' ');

  return (
    <Component ref={ref} className={className}>
      {words.map((word, index) => (
        <span key={index} className="inline-block overflow-hidden mr-2 descender-safe-inline">
          <span
            className="descender-safe-inline"
            style={{
              display: 'inline-block',
              opacity: isInView ? 1 : 0,
              transform: isInView ? 'translateY(0)' : 'translateY(100%)',
              transition: `opacity 0.5s ease-out ${delay + index * 0.08}s, transform 0.5s ease-out ${delay + index * 0.08}s`,
              willChange: 'opacity, transform',
            }}
          >
            {word}
          </span>
        </span>
      ))}
    </Component>
  );
};

export default AnimatedText;